import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { getCookie } from "../../../../util/cookie/cookies";
export interface Props {scroll : any}
export const Section5:React.FC<Props> = ({scroll}) => {
    const [selectIndex, setSelectIndex] = useState<number>(1);
    const handleTabChange = (list:{idx:number,title:string}) => {setSelectIndex(list?.idx)}
    const lang = getCookie('HYUNDAILANG')
    const {t} = useTranslation()
    return(
        <>
        <section className="mainSection_5">
            <div>
                <div className="left">
                    <div className="tab_btnBox" ref={(e)=>scroll.current[4]=e}>
                        <span>
                            <span>{t("main_section_10")}</span>
                        </span>
                        <div>
                            {적용분야.map((list:any) => (
                                <button className={selectIndex===list?.idx?'active':''} onClick={()=>handleTabChange(list)}>
                                    {lang === 'kr' ? list.title : list.title_en}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="tab_contentBox">
                        <div className={selectIndex===1?'active':''}>
                            <h2>
                                <span>{t("main_section_11")}:</span>
                                {t("main_section_12")}
                            </h2>
                            <p>
                            {t("main_section_13")}
                            </p>
                            <ul>
                                <li>{t("main_section_14")}</li>
                                <li>{t("main_section_15")}</li>
                                <li>{t("main_section_16")}</li>
                                <li>{t("main_section_17")}</li>
                                <li>{t("main_section_18")}</li>
                            </ul>
                        </div>
                        {/* <!-- 고부하출력 Fin --> */}

                        <div className={selectIndex===2?'active':''}>
                            <h2>
                                <span>{t("main_section_19")}:</span>
                                {t("main_section_20")}
                            </h2>
                            <p>
                                {t("main_section_21")}
                            </p>
                            <ul>
                                <li>{t("main_section_22")}</li>
                                <li>{t("main_section_23")}</li>
                                <li>{t("main_section_24")}</li>
                                <li>{t("main_section_25")}</li>
                                <li>{t("main_section_26")}</li>
                            </ul>
                        </div>
                        {/* <!-- 중부하출력 Fin --> */}

                        <div className={selectIndex===3?'active':''}>
                            <h2>
                                <span>{t("main_section_27")}:</span>
                                {t("main_section_28")}
                            </h2>
                            <p>
                            {t("main_section_29")}
                            </p>
                            <ul>
                                <li>{t("main_section_30")}</li>
                                <li>{t("main_section_31")}</li>
                                <li>{t("main_section_32")}</li>
                                <li>{t("main_section_33")}</li>
                                <li>{t("main_section_34")}</li>
                            </ul>
                        </div>
                        {/* <!-- 경부하출력 Fin --> */}
                    </div>
                </div>
                <div className="right">
                    <div className={selectIndex === 1?'imgBox active':'imgBox'}>
                        <img src="/assets/images/mainSection_5_tab1.png" alt="고부하출력"/>
                    </div>
                    {/* <!-- 고부하출력 이미지 Fin --> */}

                    <div className={selectIndex === 2?'imgBox active':'imgBox'}>
                        <img src="/assets/images/mainSection_5_tab1.png" alt="고부하출력"/>
                    </div>
                    {/* <!-- 중부하출력 이미지 Fin --> */}

                    <div className={selectIndex === 3?'imgBox active':'imgBox'}>
                        <img src="/assets/images/mainSection_5_tab1.png" alt="고부하출력"/>
                    </div>
                    {/* <!-- 경부하출력 이미지 Fin --> */}
                </div>
            </div>
        </section>
        </>
    )
}

export const 적용분야 = [{idx:1, title:'고부하출력', title_en : 'Heavy Duty'},{idx:2, title :'중부하출력', title_en : 'Medium Duty'},{idx:3, title:'경부하출력', title_en : 'Light Duty'}]